import restUtils from "core/utils/rest";
import {
  upliftTrackerTransformer,
  UpliftTrackerListResponse,
} from "./transformers/uplift";

export type GetUpliftTrackerListParams = {
  limit?: string;
  skip?: string;
  name?: string;
  personId?: string;
  adviser?: string;
  includeSubmitted?: boolean;
  upliftDateFrom?: string;
  upliftDateTo?: string;
};

export const getUpliftTrackerList = (params: GetUpliftTrackerListParams) => {
  return restUtils
    .call<UpliftTrackerListResponse>(
      "PortalApi",
      "hubwise-api/aml/uplift-tracker-list",
      "GET",
      {
        ...params,
        fromAdmin: true,
      }
    )
    .then((response) => {
      return upliftTrackerTransformer(response);
    });
};
